import { ThemeSlug } from './common';

export interface ThemeColors {
  // semantic UI
  primary: string;
  accent: string;
  subtle: string;

  surface: string;
  body: string;
  data: string;
  icon: string;

  // color categories
  red: string;

  // FIM concepts
  stickers: string;
  skillSets: string;
  justTheFacts: string;
  gyms: string;
  knowAndShow: string;
  veryImportantFacts: string;
}

const base = {
  primary: '#5645da',
  accent: '#37B2FF',
  subtle: '#352C7E',

  surface: '#FFFFFF',
  body: '#1B1D1F',
  data: '#83E2B8',
  icon: '#b3a9fdff',

  red: '#FF505A',

  stickers: '#6250EF',
  skillSets: '#E0646B',
  justTheFacts: '#f9bf34',
  gyms: '#885CBF',
  knowAndShow: '#83E2B8',
  veryImportantFacts: '#3FB2FF',
};

/**
 * exports theme object
 */
export const themeColors: Record<ThemeSlug, ThemeColors> = {
  next: {
    ...base,
  },
  classic: {
    ...base,
  },
};
